import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { Typography } from '@material-ui/core';
import { AlertNewBooking } from 'components/CreateBooking/UI/AlertNewBooking';
import { Button, ConfirmDialog } from 'components/UI';
import { FunctionComponent, useState } from 'react';
import styles from './ExtendRecurringSeries.module.scss';

export interface ExtendRecurringSeriesProps {
    extending: boolean;
    disabled: boolean;
    onExtend: () => Promise<boolean>;
    zIndex?: number;
}

export const ExtendRecurringSeries: FunctionComponent<ExtendRecurringSeriesProps> = props => {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const confirmHandler = async () => {
        if (submitting) {
            return;
        }
        setSubmitting(true);
        const extended = await props.onExtend();
        setSubmitting(false);
        if (extended) {
            setConfirmOpen(false);
        }
    };

    return (
        <>
            <AlertNewBooking
                bWidth="2px"
                icon={faInfoCircle}
                iconSize="lg"
                iconColor="#BAA997"
                bgColor="#F8F5F1"
                bdColor="#BCB8AE"
                className={styles.alert}
            >
                <Typography className={styles.title}>Extend Recurring Series</Typography>
                <Typography className={styles.text}>
                    Create additional bookings using this recurring series configuration. Individual changes made to
                    existing bookings won&apos;t be copied.
                </Typography>
                <Button
                    label="Extend"
                    color="black"
                    onClick={() => setConfirmOpen(true)}
                    className={styles.button}
                    loading={props.extending}
                    disabled={props.disabled || props.extending}
                />
            </AlertNewBooking>
            <ConfirmDialog
                open={confirmOpen}
                title="Extend Recurring Series"
                question={
                    <Typography>
                        Create additional bookings using this recurring series configuration. Individual changes made to
                        existing bookings won&apos;t be copied.
                    </Typography>
                }
                cancelButtonLabel="Cancel"
                confirmButtonLabel="Extend"
                processing={submitting}
                onCancel={() => !submitting && setConfirmOpen(false)}
                onConfirm={confirmHandler}
                zIndex={props.zIndex}
            />
        </>
    );
};

export default ExtendRecurringSeries;
